import React from 'react';

import { ADMIN_ROUTES } from '../../../routesConstants';
import { CONFIGURATION_FEATURES_NAMES } from '../../../Types';
import { isFeatureEnabled } from '../../../Utils';
import ConfigurationScreenWithTabs from '../ConfigurationScreenWithTabs';
import { useSysconfig } from '../SystemConfigurationScreen';

import ClaimBarConfigurationsScreen from './ClaimFieldsConfiguration/ClaimBarConfigurations/ClaimBarConfigurationsScreen';
import BarFieldsConfiguration from './ClaimFieldsConfiguration/ClaimBarFieldsConfiguration';
import SidebarFieldsConfiguration from './ClaimFieldsConfiguration/ClaimSidebarFieldsConfiguration';
import ClaimFlagConfiguration from './ClaimFlagConfiguration/ClaimFlagConfiguration';
import ClaimMilestoneConfiguration from './ClaimMilestoneConfiguration/ClaimMilestoneConfiguration';
import ClaimStageConfiguration from './ClaimStageConfiguration/ClaimStageConfiguration';
import ClosingReasonConfigScreen from './ClosingReasonConfig/ClosingReasonConfigScreen';

const CLAIM_CONFIG_CONFIGURATION_SUBTITLE =
  'Configure closing reasons and customize your claim page layout, including the claim bar and sidebar, to optimize adjuster workflows.';

const ClaimConfigurationPage = () => {
  const { organization } = useSysconfig();
  const tabs = [
    {
      label: 'Closing Reasons',
      url: ADMIN_ROUTES.CLAIM_CONFIG.CLOSING_REASON,
      component: ClosingReasonConfigScreen,
      isEnabled: isFeatureEnabled(organization, CONFIGURATION_FEATURES_NAMES.NEW_CLOSING_REASON),
    },
    {
      label: 'Claim Stages',
      url: ADMIN_ROUTES.CLAIM_CONFIG.CLAIM_STAGE_CONFIGURATION,
      component: ClaimStageConfiguration,
      isEnabled: true,
    },
    {
      label: 'Claim Flags',
      url: ADMIN_ROUTES.CLAIM_CONFIG.CLAIM_FLAG_CONFIGURATION,
      component: ClaimFlagConfiguration,
      isEnabled: true,
    },
    {
      label: 'Claim Milestones',
      url: ADMIN_ROUTES.CLAIM_CONFIG.CLAIM_MILESTONE_CONFIGURATION,
      component: ClaimMilestoneConfiguration,
      isEnabled: isFeatureEnabled(organization, CONFIGURATION_FEATURES_NAMES.CLAIM_MILESTONES),
    },
    {
      label: 'Claim Bar',
      url: ADMIN_ROUTES.CLAIM_CONFIG.CLAIM_BAR_CONFIGURATION,
      component: isFeatureEnabled(organization, CONFIGURATION_FEATURES_NAMES.ADDITIONAL_FIELDS_ON_CLAIM_BAR)
        ? ClaimBarConfigurationsScreen
        : BarFieldsConfiguration,
      isEnabled: true,
    },
    {
      label: 'Claim Sidebar',
      url: ADMIN_ROUTES.CLAIM_CONFIG.CLAIM_SIDEBAR_CONFIGURATION,
      component: SidebarFieldsConfiguration,
      isEnabled: true,
    },
  ];

  return (
    <ConfigurationScreenWithTabs
      tabs={tabs}
      title="Claim Configuration"
      subtitle={CLAIM_CONFIG_CONFIGURATION_SUBTITLE}
      operationTabName="Claim Configuration"
    />
  );
};

export default ClaimConfigurationPage;
export { CLAIM_CONFIG_CONFIGURATION_SUBTITLE };
